import { rest } from 'msw'

export default [
  /**
   * refresh token
   */
   rest.get('/swc-api/token/refresh/', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json({
        "access": "dummy",
        "refresh": "dummy"
      })
    )
  }),
]
